// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_4 from 'E:/wy/wechat/senke_property_wechat/src/models/useDefaultRoom';
import model_3 from 'E:/wy/wechat/senke_property_wechat/src/models/useDefaultCustomer';
import model_1 from 'E:/wy/wechat/senke_property_wechat/src/models/useAccount';
import model_5 from 'E:/wy/wechat/senke_property_wechat/src/models/useGlobal';
import model_2 from 'E:/wy/wechat/senke_property_wechat/src/models/useCommunity';
import model_6 from 'E:/wy/wechat/senke_property_wechat/src/models/useHouse';
import model_7 from 'E:/wy/wechat/senke_property_wechat/src/models/useRepair';
import model_8 from 'E:/wy/wechat/senke_property_wechat/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_4: { namespace: 'useDefaultRoom', model: model_4 },
model_3: { namespace: 'useDefaultCustomer', model: model_3 },
model_1: { namespace: 'useAccount', model: model_1 },
model_5: { namespace: 'useGlobal', model: model_5 },
model_2: { namespace: 'useCommunity', model: model_2 },
model_6: { namespace: 'useHouse', model: model_6 },
model_7: { namespace: 'useRepair', model: model_7 },
model_8: { namespace: '@@initialState', model: model_8 },
} as const
